import { TOPBAR_HEIGHT } from '../topBar/styles';

// A little breathing room below the bar, beyond its exact rendered height,
// so a section heading isn't glued to the bottom edge of the sticky bar.
const BREATHING_ROOM = 12;

// Shifts the anchor point up by TopBar's own rendered height (shared
// constant, not a hardcoded guess) plus the breathing room above, so
// jumping to a section doesn't leave its heading hidden under the bar.
export const anchor = {
    position: 'relative',
    top: {
        xs: -(TOPBAR_HEIGHT.xs + BREATHING_ROOM),
        md: -(TOPBAR_HEIGHT.md + BREATHING_ROOM),
    },
    height: 0,
};
